// project-imports
import supportMenu from './supportMenu';

// types
import { NavItemType } from 'types/menu';
import financeMenu from './finance-menu';
import studentsMenu from './students-menu';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [financeMenu, studentsMenu, supportMenu],
};

export default menuItems;
